import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

interface ComparisonTableContainerProps {
  sticky?: boolean;
}

export const ComparisonTableContainer = styled.div<ComparisonTableContainerProps>`
  position: relative;
  width: 100%;

  ${({ sticky }) => !sticky ? '' : css`
    overflow-x: scroll;
  `}
`;

interface ComparisonTableContentProps {
  fixedWidth?: string;
}

export const ComparisonTableContent = styled.table<ComparisonTableContentProps>`
  border-spacing: 0;

  ${({ fixedWidth }) => !fixedWidth ? '' : css`
    position: relative;
    width: ${fixedWidth};
  `}

  p {
    margin: auto 0;

    @media screen and (max-width: ${layout.subLg}) {
      font-size: 0.8rem !important; //used important to fully overwrite resource center font-size
    }
  }
`

interface ComparisonTableCellProps {
  width: string;
  background?: string;
  hideCheckIconText?: boolean;
  sticky?: boolean;
  responsiveBreakpoint?: string;
  responsiveCellPadding?: string;
}

export const ComparisonTableHeadCell = styled.th<ComparisonTableCellProps>`
  width: ${({ width }) => width};
  height: 5.6rem;

  ${({ sticky, width }) => !sticky ? '' : css`
    position: sticky;
    left: ${width};

    &:first-child {
      left: 0;
    }
  `}

  ${({ background }) => !background ? '' : css`
    background: ${background};
  `}
  div {
    margin: 0;
  }
`;

export const ComparisonTableBody = styled.tbody`
  &:before {
    content: "-";
    display: block;
    line-height: 0.7rem;
    color: transparent;
  }
`

interface ComparisonTableRowProps {
  borderWidth?: number;
}

export const ComparisonTableRow = styled.tr<ComparisonTableRowProps>`
  ${({ borderWidth }) => !borderWidth ? '' : css`
    td {
      border-top-width: 0;
      border-right-width: ${borderWidth}px;
      border-bottom-width: ${borderWidth}px;
      border-left-width: 0;
      border-style: solid;

      div {
        margin: 0;
      }
    }

    &:first-of-type {
      td {
        border-top-width: ${borderWidth}px;
      }
    }
  `}
`;

interface ComparisonTableCellContentProps {
  breakpoint?: string;
}

export const ComparisonTableCellContent = styled.div<ComparisonTableCellContentProps>`
  ${({ breakpoint }) => !breakpoint ? '' : css`
    @media screen and (max-width: ${breakpoint}) {
      display: none;
    }
  `}
`

export const ComparisonTableRowCell = styled.td<ComparisonTableCellProps>`
  width: ${({ width }) => width};
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  padding: 1rem 2rem;

  ${({ sticky, width }) => !sticky ? '' : css`
    position: sticky;
    left: ${width};

    &:first-child {
      left: 0;
    }
  `}

  @media screen and (max-width: ${layout.subLg}) {
    a {
      font-size: .75em;
      padding: .5em .25em;

      span:last-child {
        top: 110%;
      }
    }

    svg {
      max-width: 26px;
      min-width: 26px;
    }
  }

  ${({ responsiveCellPadding, responsiveBreakpoint }) => !responsiveCellPadding ? '' : css`
    @media all and (max-width: ${responsiveBreakpoint}) {
      padding: ${responsiveCellPadding};
    }
  `}

  ${({ hideCheckIconText }) => !hideCheckIconText ? '' : css`
    > div {
      display: grid;
      justify-content: center;
    }
  `}

  ${({ background }) => !background ? '' : css`
    background: ${background};
  `}
`;
